'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIPKidPlanCards = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIPKidPlanCards = exports.VIPKidPlanCards = function VIPKidPlanCards() {
  return _react2.default.createElement(
    'div',
    { className: 'pricing color-background-light pb++' },
    _react2.default.createElement(
      'div',
      { className: 'pricing__subtitle pricing__subtitle--loud' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'pricing.vipkid.subtitle',
        defaultMessage: 'Discover the new way to work out at home with our top trainers'
      })
    ),
    _react2.default.createElement(
      'h2',
      { className: 'pricing__header' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'pricing.vipkid.header',
        defaultMessage: 'Exclusive for VIPKID teachers'
      })
    )
  );
};